import React, { useState } from 'react';
import {
  Card, Table, Form, Input, Select, Button, Space,
  Tag, Typography, Modal, Drawer, Descriptions,
  Upload, InputNumber, message, Empty, Radio
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  PlusOutlined,
  EyeOutlined,
  InboxOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;
const { Option } = Select;
const { Dragger } = Upload;
const { TextArea } = Input;

// 操作类型映射
const OP_TYPE_MAP = {
  topup: { label: '授权直充', color: 'green' },
  refund: { label: '授权退款', color: 'orange' },
};

// TODO: 联调时替换为接口数据
const MOCK_RECORDS = [
  {
    id: 'DT202605200001',
    type: 'topup',
    time: '2026-05-20 14:30:00',
    operatorName: '张运营',
    operatorAccount: 'zhangyunying',
    enterpriseName: '深圳智联科技有限公司',
    enterpriseId: 'ENT_20240301_001',
    productName: '智能摄像机 Q1',
    productId: 'PROD_001',
    quantity: 5000,
    proofFile: '转账回执_20260520.png',
    remark: '企业打款 50,000 元，按 10 元/授权折算，充值 5,000 个'
  },
  {
    id: 'DT202605200002',
    type: 'refund',
    time: '2026-05-20 15:00:00',
    operatorName: '张运营',
    operatorAccount: 'zhangyunying',
    enterpriseName: '深圳智联科技有限公司',
    enterpriseId: 'ENT_20240301_001',
    productName: '智能摄像机 Q1',
    productId: 'PROD_001',
    quantity: 500,
    proofFile: '退款审批_20260520.png',
    remark: '上笔直充多充了 500 个，需退回'
  },
  {
    id: 'DT202605190012',
    type: 'topup',
    time: '2026-05-19 10:15:00',
    operatorName: '李运营',
    operatorAccount: 'liyunying',
    enterpriseName: '杭州云智设备有限公司',
    enterpriseId: 'ENT_20240215_008',
    productName: '双目室外机 W2',
    productId: 'PROD_W2',
    quantity: 10000,
    proofFile: '银行流水_20260519.pdf',
    remark: ''
  },
  {
    id: 'DT202605180045',
    type: 'topup',
    time: '2026-05-18 16:42:00',
    operatorName: '张运营',
    operatorAccount: 'zhangyunying',
    enterpriseName: '北京万物互联科技有限公司',
    enterpriseId: 'ENT_20240120_003',
    productName: '4G云台机 C201',
    productId: 'PROD_C201',
    quantity: 2000,
    proofFile: '转账截图_20260518.jpg',
    remark: '打款 15,000 元'
  },
];

// TODO: 联调时替换为接口数据
const MOCK_ENTERPRISES = [
  { id: 'ENT_20240301_001', name: '深圳智联科技有限公司' },
  { id: 'ENT_20240215_008', name: '杭州云智设备有限公司' },
  { id: 'ENT_20240120_003', name: '北京万物互联科技有限公司' },
];

// TODO: 联调时替换为接口数据
const MOCK_PRODUCTS = {
  'ENT_20240301_001': [
    { id: 'PROD_001', name: '智能摄像机 Q1' },
    { id: 'PROD_002', name: '智能门锁 D1' },
  ],
  'ENT_20240215_008': [
    { id: 'PROD_W2', name: '双目室外机 W2' },
  ],
  'ENT_20240120_003': [
    { id: 'PROD_C201', name: '4G云台机 C201' },
    { id: 'PROD_C300', name: '全景摄像机 P360' },
  ],
};

// TODO: 联调时替换为接口数据 — 模拟各产品当前授权余额
const MOCK_BALANCE = {
  'PROD_001': 8500,
  'PROD_002': 3000,
  'PROD_W2': 15000,
  'PROD_C201': 5000,
  'PROD_C300': 2000,
};

// ══════════════════════════════════════════════
//  主组件：DirectTopup
// ══════════════════════════════════════════════

const DirectTopup = () => {
  const [form] = Form.useForm();
  const [topupForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(MOCK_RECORDS);
  const [topupVisible, setTopupVisible] = useState(false);
  const [detailVisible, setDetailVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [selectedEnterprise, setSelectedEnterprise] = useState(null);
  const [proofVisible, setProofVisible] = useState(false);
  const [proofFileName, setProofFileName] = useState('');
  const [operationType, setOperationType] = useState('topup');
  const [currentBalance, setCurrentBalance] = useState(null);

  // 发起操作
  const handleCreate = () => {
    topupForm.resetFields();
    setSelectedEnterprise(null);
    setOperationType('topup');
    setCurrentBalance(null);
    setTopupVisible(true);
  };

  // 操作类型切换
  const handleTypeChange = (e) => {
    setOperationType(e.target.value);
    // 切换类型时重新校验数量（退款校验余额）
  };

  // 产品选择变化时更新当前余额
  const handleProductChange = (value) => {
    const balance = MOCK_BALANCE[value];
    setCurrentBalance(balance !== undefined ? balance : null);
  };

  // 提交操作
  const handleSubmit = async () => {
    try {
      const values = await topupForm.validateFields();
      setSubmitting(true);

      // 退款时校验余额
      if (operationType === 'refund' && currentBalance !== null && values.quantity > currentBalance) {
        message.error(`授权余额不足，当前余额为 ${currentBalance.toLocaleString()}`);
        setSubmitting(false);
        return;
      }

      // TODO: 联调时替换为接口请求
      const newRecord = {
        id: 'DT' + Date.now(),
        type: operationType,
        time: new Date().toLocaleString('zh-CN', { hour12: false }),
        operatorName: '当前运营',
        operatorAccount: 'current_user',
        enterpriseName: MOCK_ENTERPRISES.find(e => e.id === values.enterpriseId)?.name || '',
        enterpriseId: values.enterpriseId,
        productName: MOCK_PRODUCTS[values.enterpriseId]?.find(p => p.id === values.productId)?.name || '',
        productId: values.productId,
        quantity: values.quantity,
        proofFile: values.proofFile?.[0]?.name || '',
        remark: values.remark || '',
      };
      setData([newRecord, ...data]);
      message.success('操作成功');
      setTopupVisible(false);
      topupForm.resetFields();
    } catch (err) {
      if (err.errorFields) return;
      message.error('提交失败，请稍后重试');
    } finally {
      setSubmitting(false);
    }
  };

  // 查看详情
  const handleDetail = (record) => {
    setCurrentRecord(record);
    setDetailVisible(true);
  };

  // 筛选
  const onSearch = () => {
    setLoading(true);
    const values = form.getFieldsValue();
    setTimeout(() => {
      let filtered = [...MOCK_RECORDS];
      if (values.operationType) {
        filtered = filtered.filter(r => r.type === values.operationType);
      }
      if (values.enterpriseId) {
        filtered = filtered.filter(r => r.enterpriseId === values.enterpriseId);
      }
      if (values.productId) {
        filtered = filtered.filter(r => r.productId === values.productId);
      }
      if (values.operator) {
        filtered = filtered.filter(r =>
          r.operatorName.includes(values.operator) || r.operatorAccount.includes(values.operator)
        );
      }
      setData(filtered);
      setLoading(false);
    }, 300);
  };

  // 重置
  const onReset = () => {
    form.resetFields();
    setData(MOCK_RECORDS);
  };

  const columns = [
    {
      title: '记录 ID',
      dataIndex: 'id',
      key: 'id',
      width: 170,
      render: (val) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{val}</Text>
    },
    {
      title: '操作类型',
      dataIndex: 'type',
      key: 'type',
      width: 110,
      render: (val) => {
        const config = OP_TYPE_MAP[val];
        return <Tag color={config.color} style={{ border: 'none' }}>{config.label}</Tag>;
      }
    },
    {
      title: '操作时间',
      dataIndex: 'time',
      key: 'time',
      width: 170,
      sorter: (a, b) => a.time.localeCompare(b.time),
    },
    {
      title: '操作人',
      key: 'operator',
      width: 120,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.operatorName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>{record.operatorAccount}</Text>
        </div>
      )
    },
    {
      title: '所属企业',
      key: 'enterprise',
      width: 200,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.enterpriseName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {record.enterpriseId}</Text>
        </div>
      )
    },
    {
      title: '目标产品',
      key: 'product',
      width: 160,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.productName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>PID: {record.productId}</Text>
        </div>
      )
    },
    {
      title: '授权数量',
      key: 'quantity',
      width: 100,
      align: 'right',
      render: (_, record) => {
        const val = record.quantity;
        const display = record.type === 'refund' ? `-${val.toLocaleString()}` : `+${val.toLocaleString()}`;
        const color = record.type === 'refund' ? '#ff4d4f' : '#52c41a';
        return <span style={{ color, fontWeight: 500 }}>{display}</span>;
      }
    },
    {
      title: '凭证',
      key: 'proof',
      width: 160,
      render: (_, record) => (
        <Text
          style={{ color: '#1890ff', cursor: 'pointer', fontSize: 12 }}
          onClick={() => { setProofFileName(record.proofFile); setProofVisible(true); }}
        >
          {record.proofFile}
        </Text>
      )
    },
    {
      title: '状态',
      key: 'status',
      width: 90,
      render: (_, record) => {
        const config = OP_TYPE_MAP[record.type];
        const label = record.type === 'topup' ? '已充值' : '已退款';
        return <Tag color={config.color} style={{ border: 'none' }}>{label}</Tag>;
      }
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      fixed: 'right',
      render: (_, record) => (
        <Button
          type="link"
          size="small"
          icon={<EyeOutlined />}
          onClick={() => handleDetail(record)}
        >
          查看详情
        </Button>
      )
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>生产授权直充</Title>
      </div>

      {/* 筛选区 */}
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form form={form} layout="inline">
          <Form.Item name="operationType" style={{ marginBottom: 0 }}>
            <Select placeholder="操作类型" allowClear style={{ width: 140 }}>
              <Option value="topup">授权直充</Option>
              <Option value="refund">授权退款</Option>
            </Select>
          </Form.Item>

          <Form.Item name="enterpriseId" style={{ marginBottom: 0 }}>
            <Select
              placeholder="所属企业"
              allowClear
              showSearch
              optionFilterProp="children"
              style={{ width: 200 }}
            >
              {MOCK_ENTERPRISES.map(e => (
                <Option key={e.id} value={e.id}>{e.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="productId" style={{ marginBottom: 0 }}>
            <Select
              placeholder="目标产品"
              allowClear
              showSearch
              optionFilterProp="children"
              style={{ width: 180 }}
            >
              {Object.values(MOCK_PRODUCTS).flat().map(p => (
                <Option key={p.id} value={p.id}>{p.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="operator" style={{ marginBottom: 0 }}>
            <Input placeholder="操作人" allowClear style={{ width: 140 }} />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* 表格区 */}
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
            发起操作
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          loading={loading}
          bordered={false}
          scroll={{ x: 1500 }}
          pagination={{
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 条记录`,
            pageSize: 10,
          }}
          locale={{
            emptyText: (
              <div style={{ padding: '40px 0' }}>
                <InboxOutlined style={{ fontSize: 48, color: '#d9d9d9' }} />
                <div style={{ marginTop: 8, color: '#999' }}>暂无记录</div>
              </div>
            )
          }}
        />
      </Card>

      {/* ══════════════════════════════════════════════
           发起操作弹窗
         ══════════════════════════════════════════════ */}
      <Modal
        title={`发起${OP_TYPE_MAP[operationType].label}`}
        open={topupVisible}
        onOk={handleSubmit}
        onCancel={() => setTopupVisible(false)}
        confirmLoading={submitting}
        width={560}
        destroyOnClose
        okText="提交"
        cancelText="取消"
      >
        <Form form={topupForm} layout="vertical" style={{ marginTop: 16 }}>
          {/* 操作类型 */}
          <Form.Item
            label="操作类型"
            rules={[{ required: true, message: '请选择操作类型' }]}
          >
            <Radio.Group value={operationType} onChange={handleTypeChange}>
              <Radio.Button value="topup">授权直充</Radio.Button>
              <Radio.Button value="refund">授权退款</Radio.Button>
            </Radio.Group>
          </Form.Item>

          {/* 目标企业 */}
          <Form.Item
            name="enterpriseId"
            label="目标企业"
            rules={[{ required: true, message: '请选择目标企业' }]}
          >
            <Select
              placeholder="请搜索并选择企业"
              showSearch
              optionFilterProp="children"
              onChange={(val) => { setSelectedEnterprise(val); topupForm.setFieldsValue({ productId: undefined }); setCurrentBalance(null); }}
            >
              {MOCK_ENTERPRISES.map(e => (
                <Option key={e.id} value={e.id}>{e.name}</Option>
              ))}
            </Select>
          </Form.Item>

          {/* 目标产品 */}
          <Form.Item
            name="productId"
            label="目标产品"
            rules={[{ required: true, message: '请选择目标产品' }]}
          >
            <Select
              placeholder={selectedEnterprise ? '请选择产品' : '请先选择企业'}
              showSearch
              optionFilterProp="children"
              disabled={!selectedEnterprise}
              onChange={handleProductChange}
            >
              {(MOCK_PRODUCTS[selectedEnterprise] || []).map(p => (
                <Option key={p.id} value={p.id}>{p.name}</Option>
              ))}
            </Select>
          </Form.Item>

          {/* 余额提示（退款时显示） */}
          {operationType === 'refund' && currentBalance !== null && (
            <div style={{
              background: '#fff7e6',
              border: '1px solid #ffd591',
              borderRadius: 6,
              padding: '8px 12px',
              marginBottom: 16,
              fontSize: 13
            }}>
              当前授权余额：<Text strong style={{ color: '#fa8c16' }}>{currentBalance.toLocaleString()}</Text>
            </div>
          )}

          {/* 授权数量 */}
          <Form.Item
            name="quantity"
            label={
              <span>授权数量 <Text type="secondary" style={{ fontSize: 12 }}>（1 ~ 100,000）</Text></span>
            }
            rules={[
              { required: true, message: '请输入授权数量' },
              { type: 'number', min: 1, message: '请输入正整数' },
              {
                validator: (_, value) => {
                  if (value > 100000) return Promise.reject(new Error('单次操作数量不得超过 100,000'));
                  if (operationType === 'refund' && currentBalance !== null && value > currentBalance) {
                    return Promise.reject(new Error(`授权余额不足，当前余额为 ${currentBalance.toLocaleString()}`));
                  }
                  return Promise.resolve();
                }
              }
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              max={100000}
              precision={0}
              placeholder="请输入数量"
            />
          </Form.Item>

          {/* 凭证上传 */}
          <Form.Item
            name="proofFile"
            label={operationType === 'refund' ? '退款凭证' : '打款凭证'}
            rules={[{ required: true, message: '请上传凭证' }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
          >
            <Dragger
              maxCount={1}
              accept=".jpg,.jpeg,.png,.pdf"
              beforeUpload={(file) => {
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isLt10M) {
                  message.error('文件大小不能超过 10MB');
                  return Upload.LIST_IGNORE;
                }
                const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
                if (!isValidType) {
                  message.error('仅支持 jpg / png / pdf 格式');
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
              <p className="ant-upload-hint">支持 jpg / png / pdf，单文件不超过 10MB</p>
            </Dragger>
          </Form.Item>

          {/* 备注/退款原因 */}
          <Form.Item
            name="remark"
            label={operationType === 'refund' ? '退款原因' : '备注（选填）'}
            rules={[
              { max: 500, message: '不超过 500 字' },
              ...(operationType === 'refund'
                ? [{ required: true, message: '请填写退款原因' }]
                : [])
            ]}
          >
            <TextArea
              rows={3}
              placeholder={operationType === 'refund' ? '请填写退款原因' : '如打款金额、打款时间、打款方信息等'}
              showCount
              maxLength={500}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* ══════════════════════════════════════════════
           记录详情抽屉
         ══════════════════════════════════════════════ */}
      <Drawer
        title="操作记录详情"
        open={detailVisible}
        onClose={() => setDetailVisible(false)}
        width={560}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button onClick={() => setDetailVisible(false)}>关闭</Button>
          </div>
        }
      >
        {currentRecord && (
          <>
            <Descriptions title="基本信息" bordered column={2} size="small" style={{ marginBottom: 24 }}>
              <Descriptions.Item label="记录 ID" span={2}>
                <Text copyable style={{ fontFamily: 'monospace' }}>{currentRecord.id}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="操作类型">
                {(() => {
                  const c = OP_TYPE_MAP[currentRecord.type];
                  return <Tag color={c.color} style={{ border: 'none' }}>{c.label}</Tag>;
                })()}
              </Descriptions.Item>
              <Descriptions.Item label="操作时间">{currentRecord.time}</Descriptions.Item>
              <Descriptions.Item label="操作人" span={2}>
                {currentRecord.operatorName}（{currentRecord.operatorAccount}）
              </Descriptions.Item>
              <Descriptions.Item label="状态">
                {(() => {
                  const c = OP_TYPE_MAP[currentRecord.type];
                  const label = currentRecord.type === 'topup' ? '已充值' : '已退款';
                  return <Tag color={c.color} style={{ border: 'none' }}>{label}</Tag>;
                })()}
              </Descriptions.Item>
            </Descriptions>

            <Descriptions title="操作信息" bordered column={2} size="small" style={{ marginBottom: 24 }}>
              <Descriptions.Item label="所属企业" span={2}>
                {currentRecord.enterpriseName}
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>ID: {currentRecord.enterpriseId}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="目标产品" span={2}>
                {currentRecord.productName}
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>PID: {currentRecord.productId}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="授权数量">
                {currentRecord.type === 'refund'
                  ? <Text type="danger">-{currentRecord.quantity.toLocaleString()}</Text>
                  : <Text style={{ color: '#52c41a', fontWeight: 500 }}>+{currentRecord.quantity.toLocaleString()}</Text>
                }
              </Descriptions.Item>
            </Descriptions>

            <Descriptions title="凭证与备注" bordered column={1} size="small">
              <Descriptions.Item label="凭证">
                <Text
                  style={{ color: '#1890ff', cursor: 'pointer' }}
                  onClick={() => { setProofFileName(currentRecord.proofFile); setProofVisible(true); }}
                >
                  {currentRecord.proofFile}
                </Text>
              </Descriptions.Item>
              <Descriptions.Item label={currentRecord.type === 'refund' ? '退款原因' : '备注'}>
                {currentRecord.remark || <Text type="secondary">—</Text>}
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </Drawer>

      {/* ══════════════════════════════════════════════
           凭证预览弹窗
         ══════════════════════════════════════════════ */}
      <Modal
        title={`凭证预览 - ${proofFileName}`}
        open={proofVisible}
        onCancel={() => setProofVisible(false)}
        footer={null}
        width={640}
        destroyOnClose
      >
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Empty description="暂无凭证图片数据" />
        </div>
      </Modal>
    </div>
  );
};

export default DirectTopup;
